import {
  ChartFrequency,
  CommunicationType,
  ICommunicationAnalytics,
  IEmailAnalyticsFilter,
  IJobCandidateInteraction,
} from 'wisestep-api';
import {
  getCurrentZoneAbbr,
  getCurrentZoneAbbrInHour,
  getCurrentZoneAbbrInMinute,
} from 'wisestep-base';

export const defaultCallAnalyticsValues: ICommunicationAnalytics = {
  forTeams: false,
  direction: null,
  utcOffset: getCurrentZoneAbbr(),
  utcOffsetInHour: parseInt(getCurrentZoneAbbrInHour()),
  utcOffsetInMinute: parseInt(getCurrentZoneAbbrInMinute()),
  recruiterName: '',
  frequency: ChartFrequency.HOURS,
  type: CommunicationType.CALL,
  fromDay: '',
  loadAllWorkspacesData: false,
  source: [],
  recruiterNames: [],
};

export const defaultEmailAnalyticsValues: IEmailAnalyticsFilter = {
  utcOffset: getCurrentZoneAbbr(),
  utcOffsetInHour: parseInt(getCurrentZoneAbbrInHour()),
  utcOffsetInMinute: parseInt(getCurrentZoneAbbrInMinute()),
  recruiterId: '',
  frequency: ChartFrequency.HOURS,
  fromDay: '',
  recruiterNames: [],
};

export const defaultMISAnalyticsPaylod: ICommunicationAnalytics & IJobCandidateInteraction = {
  forTeams: false,
  direction: null,
  utcOffset: getCurrentZoneAbbr(),
  utcOffsetInHour: parseInt(getCurrentZoneAbbrInHour()),
  utcOffsetInMinute: parseInt(getCurrentZoneAbbrInMinute()),
  recruiterName: '' as any,
  frequency: ChartFrequency.WEEKLY,
  type: null,
  fromDay: '',
  page: 0,
  loadAllWorkspacesData: false,
};
